import { render } from "./Contacts.vue?vue&type=template&id=a24c925e&scoped=true"
import script from "./Contacts.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Contacts.vue?vue&type=script&charset=utf-8&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=a24c925e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a24c925e"]])

export default __exports__